import { z } from "zod/v4-mini";

import { CGMDexcomDataEvent } from "@/lib/drivers/tandem/events/LID_CGM_DATA_G7";
import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CGMGXBDataSamplePayload = {
  status?: number;
  type?: number;
  rate?: number;
  rssi?: number;
  value?: number;
  timestamp?: number;
  transmitter_timestamp?: number;
};

const cGMGXBDataSampleSchema = z.object({
  status: cz.permissive(z.number()),
  type: cz.permissive(z.number()),
  rate: cz.permissive(z.number()),
  rssi: cz.permissive(z.number()),
  value: cz.permissive(z.number()),
  timestamp: cz.permissive(z.number()),
  transmitter_timestamp: cz.permissive(z.number()),
});

export const LID_CGM_DATA_GXB = {
  value: 0x100,
  name: "CGM GXB Data Sample",
  format: "sby.ysii",
  fields: ["status", "type", "rate", "rssi", "value", "timestamp", "transmitter_timestamp"],
  postprocess: rec => rec,
  schema: cGMGXBDataSampleSchema,
} as const satisfies TandemEventDefinition<CGMGXBDataSamplePayload, CGMDexcomDataEvent>;
